import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { OFFICE_INTRO_SAMPLE } from "../consts";
import { OfficeSceneProps } from "../types";

/** Korak "Korisnici": tim poslovnice s ulogama. */
const OfficeUserScene: React.FC<OfficeSceneProps> = ({ name }) => {
  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Korisnici</div>
          <div className="text-sm font-bold text-slate-800 truncate">{name}</div>
          <div className="mt-3 space-y-2">
            {OFFICE_INTRO_SAMPLE.users.map((user) => (
              <div key={user.name} className="flex items-center gap-3 rounded-md bg-slate-50 px-2 py-2">
                <span className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-[0.65rem] font-bold text-blue-700 flex-shrink-0">
                  {user.initials}
                </span>
                <div className="min-w-0">
                  <div className="text-[0.7rem] font-semibold text-slate-700 truncate">{user.name}</div>
                  <div className="text-[0.6rem] text-slate-400 truncate">{user.role}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Uloge</div>
          <div className="mt-3 flex flex-wrap gap-1.5">
            {OFFICE_INTRO_SAMPLE.roles.map((role) => (
              <span key={role} className="px-2 py-0.5 rounded-full text-[0.6rem] font-semibold bg-blue-50 text-blue-700">
                {role}
              </span>
            ))}
          </div>
          <div className="mt-3 text-[0.65rem] text-slate-500">
            Korisnika: <span className="font-semibold text-slate-700">{OFFICE_INTRO_SAMPLE.users.length}</span>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Svatko sa svojom prijavom"
          subtitle="Uloga određuje što tko vidi"
          iconClassName="bg-blue-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(OfficeUserScene);
